import useSectionBreakpointStyles from 'EmailEditorUI/hooks/styleSettings/useSectionBreakpointStyles';
const useSectionSpacingCss = (section, selectable) => {
  const {
    paddingBottom,
    paddingTop
  } = useSectionBreakpointStyles(section);
  const styles = {};
  if (!selectable || !section) {
    return styles;
  }
  if (paddingTop && paddingTop !== '0px') {
    styles.paddingTop = paddingTop;
  }
  if (paddingBottom && paddingBottom !== '0px') {
    styles.paddingBottom = paddingBottom;
  }
  return styles;
};
export default useSectionSpacingCss;